import { css } from '@emotion/react'
import { Color, Size, Spacing, Theme, Typography } from '@opallabs/gem'

export const inline = (theme: Theme) =>
  css({
    ...Typography.T500,
    alignItems: 'center',
    border: `1px solid ${Color[theme].Surface.N300}`,
    borderRadius: Size.Rounding,
    color: Color[theme].Text.Default,
    cursor: 'pointer',
    display: 'inline-flex',
    padding: Spacing.XS,
    textDecoration: 'none',
    userSelect: 'none',

    '.embedded-resource-text': {
      color: Color[theme].Text.Default,
    },

    '.embedded-resource-icon': {
      marginInlineEnd: Spacing.XS,
    },
  })
